import React from 'react';
import { PropTypes } from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Step from './Step';

import { CarouselTypes } from '../consts';

const StepNavigation = ({
    styles,
    slides,
    currentSlide,
    nextSlide,
    type,
    isLarge,
    handleHover,
    moveToSlideId,
    withButtons,
}) => (
    <div className={styles.container}>
        {type === CarouselTypes.CASE_STUDIES && (
            <h2 className={styles.title}>
                <FormattedMessage id="homepage.caseStudies.navigation.title" />
            </h2>
        )}
        <div data-current-carousel-slide={`${currentSlide + 1};${slides.length}`} className={styles.stepsContainer}>
            {React.useMemo(
                () =>
                    slides.length > 1 &&
                    slides.map((item, index) => (
                        <Step
                            isCurrent={currentSlide === index}
                            key={item.id}
                            slideId={index}
                            order={index + 1}
                            isLast={index === slides.length - 1}
                            nextSlide={nextSlide}
                            type={type}
                            isLarge={isLarge}
                            hoverTitle={item.heading}
                            navigationTitle={item.navigationTitle ?? null}
                            handleHover={handleHover}
                            moveToSlideId={moveToSlideId}
                            currentCarouselSlide={`${currentSlide + 1};${slides.length}`}
                        />
                    )),
                [slides, currentSlide, nextSlide, isLarge, type, handleHover, moveToSlideId],
            )}
        </div>
    </div>
);

StepNavigation.propTypes = {
    styles: PropTypes.shape({
        container: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
    }).isRequired,
    slides: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    currentSlide: PropTypes.number.isRequired,
    nextSlide: PropTypes.func.isRequired,
    type: PropTypes.string.isRequired,
    isLarge: PropTypes.bool,
    handleHover: PropTypes.func,
    moveToSlideId: PropTypes.func,
};

StepNavigation.defaultProps = {
    isLarge: false,
    handleHover: null,
    moveToSlideId: null,
};

export default StepNavigation;
